import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { industries } from '../mockData';
import { Button } from '../components/ui/button';
import industryPageMap from './industries/industryPageMap';

const IndustryDetail = () => {
  const { slug } = useParams();

  const industry = industries.find(i => i.slug === slug);
  const PageComponent = industryPageMap[slug];

  if (!industry || !PageComponent) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-6">Industry Not Found</h1>
          <Button asChild>
            <Link to="/industries">View All Industries</Link>
          </Button>
        </div>
      </div>
    );
  }

  return <PageComponent industry={industry} />;
};

export default IndustryDetail;
